export const ROUTE_PATH = {
  LOGIN: '/login',
  TASKS: '/',
  BACKLOG: '/backlog',
  CLIENTS: '/clients',
  SERVICES: '/services',
  EMPLOYEES: '/employees',
  REPORTS: '/reports',
  SETTINGS: '/settings'
};
